import { render, staticRenderFns } from "./EditClassRoom.vue?vue&type=template&id=317a5e75&scoped=true&"
import script from "./EditClassRoom.vue?vue&type=script&lang=js&"
export * from "./EditClassRoom.vue?vue&type=script&lang=js&"
import style0 from "./EditClassRoom.vue?vue&type=style&index=0&id=317a5e75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317a5e75",
  null
  
)

export default component.exports